/*
  spx-sort-menu.js — Brilliant-Earth-style Sort dropdown for the sp-catalog toolbar.
  Vanilla ES5, IIFE, delegated on document (survives section swaps; no re-init needed).

  MARKUP (sp-catalog-toolbar.liquid):
    [data-sp-sort-menu]  wrapper
      [data-sp-sort-toggle]  the "Sort By: <value> ⌄" text button
        [data-sp-sort-value] the current label span
      [data-sp-sort-list] role=listbox  (hidden)
        [data-sp-sort-opt] role=option  data-value="<sort_by>"
      select[data-sp-sort] (hidden)     — the ENGINE's value source (spx-catalog.js applySort)

  Behavior: toggle opens/closes the menu; picking an option reflects the label + active
  state, closes the menu, then sets the hidden native select's value and dispatches a
  'change' so spx-catalog.js runs its normal sort fetch. Click-outside / Escape close it.
  (The section re-render after the fetch re-emits the toolbar with the correct state.)
*/
(function () {
  'use strict';
  if (window.spxSortMenu) { return; }
  window.spxSortMenu = true;

  function up(el, attr) {
    while (el && el.nodeType === 1) {
      if (el.hasAttribute && el.hasAttribute(attr)) { return el; }
      el = el.parentNode;
    }
    return null;
  }

  function closeAll(except) {
    var lists = document.querySelectorAll('[data-sp-sort-list]');
    for (var i = 0; i < lists.length; i++) {
      if (lists[i] === except) { continue; }
      lists[i].hidden = true;
      var wrap = up(lists[i], 'data-sp-sort-menu');
      var tog = wrap && wrap.querySelector('[data-sp-sort-toggle]');
      if (tog) { tog.setAttribute('aria-expanded', 'false'); }
    }
  }

  document.addEventListener('click', function (e) {
    var toggle = up(e.target, 'data-sp-sort-toggle');
    if (toggle) {
      e.preventDefault();
      var wrap = up(toggle, 'data-sp-sort-menu');
      var menu = wrap && wrap.querySelector('[data-sp-sort-list]');
      if (!menu) { return; }
      var willOpen = menu.hidden;
      closeAll(willOpen ? menu : null);
      menu.hidden = !willOpen;
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      return;
    }

    var opt = up(e.target, 'data-sp-sort-opt');
    if (opt) {
      e.preventDefault();
      var wrap2 = up(opt, 'data-sp-sort-menu');
      if (!wrap2) { return; }
      var val = opt.getAttribute('data-value');
      var valEl = wrap2.querySelector('[data-sp-sort-value]');
      if (valEl) { valEl.textContent = opt.textContent; }
      var opts = wrap2.querySelectorAll('[data-sp-sort-opt]');
      for (var j = 0; j < opts.length; j++) {
        var on = opts[j] === opt;
        if (on) { opts[j].className = (opts[j].className.replace(/\bis-active\b/g, '').trim() + ' is-active').trim(); }
        else { opts[j].className = opts[j].className.replace(/\bis-active\b/g, '').replace(/\s+/g, ' ').trim(); }
        opts[j].setAttribute('aria-selected', on ? 'true' : 'false');
      }
      closeAll(null);
      var sel = wrap2.querySelector('select[data-sp-sort]');
      if (sel && sel.value !== val) {
        sel.value = val;
        var ev;
        try { ev = new Event('change', { bubbles: true }); }
        catch (x) { ev = document.createEvent('Event'); ev.initEvent('change', true, false); }
        sel.dispatchEvent(ev);
      }
      return;
    }

    /* click anywhere else closes any open menu */
    closeAll(null);
  }, false);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) { closeAll(null); }
  }, false);
})();
